export enum UserUploadedDocumentsKeys {
    CVS = 'cvs',
    COVER_LETTERS = 'cover_letters',
    PHOTO = 'photos'
}